import EligibilityTrue from "@assets/illustrations/eligibility_true.png";
import EligibilityFalse from "@assets/illustrations/qualification_refused.png";
import BottomBar from "@components/BottomBars/BottomBar";
import { AspectRatio, Box } from "@mantine/core";
import { auth } from "@utils/firebase";
import { useGetUser } from "@utils/hooks";
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";

type FactFindQualificationPostProps = {};

const FactFindQualificationPost: React.FC<
  FactFindQualificationPostProps
> = () => {
  const navigate = useNavigate();
  const { data: userData, isLoading: userLoading } = useGetUser();
  const [userAuth] = useAuthState(auth);

  const [isTaxResident, setIsTaxResident] = useState<null | boolean>(null);

  useEffect(() => {
    if (!userLoading) {
      if (userData?.is_tax_resident) {
        setIsTaxResident(userData?.is_tax_resident === "Yes" ? true : false);
      } else {
        navigate("/");
      }
    }
  }, [userData, userLoading, navigate]);

  return userLoading || isTaxResident === null ? (
    <></>
  ) : (
    <section className="grow flex items-start md:items-center justify-center border-t-4 border-l-0 md:border-t-0 md:border-l-4 border-[#F4E34E] px-0 md:px-2 lg:px-0">
      <div className="max-w-full md:max-w-[416px] w-full md:rounded-3xl md:border md:border-pn_gray-200">
        <div className="flex flex-col w-full">
          <Box className="w-full relative overflow-hidden">
            <div className="rounded-2xl relative md:overflow-hidden">
              <img
                className="w-full"
                src={isTaxResident ? EligibilityTrue : EligibilityFalse}
                alt={"Eligibility"}
              />
            </div>
            <div className="absolute top-[47%] left-0 right-0 w-full">
              <AspectRatio ratio={16 / 9}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="42"
                  viewBox="0 0 375 42"
                  fill="none"
                >
                  <path
                    d="M75.399 331.369C250.199 298.993 335.857 123.093 536.034 63.155L530.95 35.5147C323.374 75.8681 158.833 -32.7349 -6.24216 11.1731C-72.968 31.1529 -107.019 73.6584 -122.139 125.995C-146.564 210.537 -99.1907 302.739 -18.8191 325.958C9.31538 334.087 43.7863 335.321 75.399 331.369Z"
                    fill="#F8F7F3"
                  />
                </svg>
              </AspectRatio>
            </div>
          </Box>

          <div className="flex flex-col gap-y-4 pb-4 px-4 md:px-6">
            <h2 className="text-pn-large-title text-pn_gray-950">
              {isTaxResident ? (
                <>
                  You’re Eligible! <br />
                </>
              ) : (
                <>
                  Oh no! <br /> It looks like you're not eligible at this time{" "}
                </>
              )}
            </h2>
            <span className="text-pn-body-regular !font-normal text-pn_gray-600">Tell us about yourself and we’ll provide a pension recommendation tailored to you.</span>
            <span className="text-pn-body-regular !font-normal text-pn_gray-600">
              {isTaxResident ? (
                <span>
                  We've sent an email to{" "}
                  <span className="text-pn-body-emphasis text-pn_gray-950">
                    {userData?.email ?? userAuth?.email}
                  </span>{" "}
                  with a link to activate your account.
                </span>
              ) : (
                <span>
                  At the moment, Penny can only offer pensions to tax residents
                  in Ireland. <br /> <br /> If you want to speak with Penny
                  staff about this, please use the button below to contact us.
                </span>
              )}
            </span>
          </div>

          {!isTaxResident && (
            <div className="mb-10 px-4 pt-2">
              <BottomBar
                bordered={false}
                padding={false}
                layout="single"
                onNext={"/schedule-call"}
                labelNext="Book Phone Call"
                variantsPrimary="secondary"
              />
            </div>
          )}

          {isTaxResident && (
            <div className="mb-10 px-4 pt-2">
              <BottomBar
                bordered={false}
                padding={false}
                layout="stacked_back"
                onNext={"/fact-find"}
                labelNext=" Start Fact Find"
                labelBack="Go to Dashboard"
                onBack={"/"}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
export default FactFindQualificationPost;
